import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun10am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99988 1.31604C8.34506 1.31604 8.62488 1.59586 8.62488 1.94104V3.05903C8.62488 3.40421 8.34506 3.68403 7.99988 3.68403C7.6547 3.68403 7.37488 3.40421 7.37488 3.05903V1.94104C7.37488 1.59586 7.6547 1.31604 7.99988 1.31604Z"
        fill="currentColor"
      />
      <path
        d="M7.99988 12.316C8.34506 12.316 8.62488 12.5959 8.62488 12.941V14.059C8.62488 14.4042 8.34506 14.684 7.99988 14.684C7.6547 14.684 7.37488 14.4042 7.37488 14.059V12.941C7.37488 12.5959 7.6547 12.316 7.99988 12.316Z"
        fill="currentColor"
      />
      <path
        d="M14.6838 8C14.6838 8.34518 14.404 8.625 14.0588 8.625H12.9408C12.5957 8.625 12.3158 8.34518 12.3158 8C12.3158 7.65482 12.5957 7.375 12.9408 7.375H14.0588C14.404 7.375 14.6838 7.65482 14.6838 8Z"
        fill="currentColor"
      />
      <path
        d="M3.68384 8C3.68384 8.34518 3.40402 8.625 3.05884 8.625H1.94085C1.59567 8.625 1.31585 8.34518 1.31585 8C1.31585 7.65482 1.59567 7.375 1.94085 7.375H3.05884C3.40402 7.375 3.68384 7.65482 3.68384 8Z"
        fill="currentColor"
      />
      <path
        d="M12.7261 3.27376C12.9702 3.51784 12.9702 3.91357 12.7261 4.15764L11.9356 4.94818C11.6915 5.19226 11.2958 5.19226 11.0517 4.94818C10.8076 4.7041 10.8076 4.30838 11.0517 4.0643L11.8422 3.27376C12.0863 3.02968 12.482 3.02968 12.7261 3.27376Z"
        fill="currentColor"
      />
      <path
        d="M4.94804 11.052C5.19212 11.296 5.19212 11.6918 4.94804 11.9358L4.15751 12.7264C3.91343 12.9705 3.5177 12.9705 3.27362 12.7264C3.02954 12.4823 3.02954 12.0866 3.27362 11.8425L4.06416 11.052C4.30824 10.8079 4.70397 10.8079 4.94804 11.052Z"
        fill="currentColor"
      />
      <path
        d="M12.7261 12.7264C12.4821 12.9704 12.0863 12.9704 11.8423 12.7264L11.0517 11.9358C10.8076 11.6917 10.8076 11.296 11.0517 11.0519C11.2958 10.8079 11.6915 10.8079 11.9356 11.0519L12.7261 11.8425C12.9702 12.0866 12.9702 12.4823 12.7261 12.7264Z"
        fill="currentColor"
      />
      <path
        d="M4.94807 4.94817C4.70399 5.19225 4.30827 5.19225 4.06419 4.94817L3.27365 4.15763C3.02957 3.91355 3.02957 3.51782 3.27365 3.27374C3.51773 3.02967 3.91346 3.02967 4.15753 3.27374L4.94807 4.06428C5.19215 4.30836 5.19215 4.70409 4.94807 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99981 11.6801C9.24612 11.6801 10.3477 11.0605 11.0134 10.1126C11.4259 9.56671 11.6799 8.82155 11.6799 8.00006C11.6799 7.17842 11.4258 6.43315 11.0132 5.88724C10.3475 4.93949 9.24598 4.32007 7.99981 4.32007C5.9674 4.32007 4.31981 5.96766 4.31981 8.00007C4.31981 10.0325 5.9674 11.6801 7.99981 11.6801ZM6.9688 8.00006C6.9688 8.99383 7.34053 9.87589 7.91484 10.4286C6.61213 10.3838 5.56981 9.31368 5.56981 8.00007C5.56981 6.68646 6.61212 5.61631 7.91481 5.57153C7.34052 6.12424 6.9688 7.0063 6.9688 8.00006Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun10am;
